import {
    FILTER_USER_MEMBERSHIP,
    SORT_USER_MEMBERSHIP,
    TABLE_USER_MEMBERSHIP,
} from 'configs/loyalty-program/configTableUserMembership'
import Search from 'components/commons/search'
import Filter from 'components/commons/filter'
import { Button } from 'avo-ui'
import icTrash from 'assets/images/ic-trash.svg'
import { ACTION_TYPE } from 'constants/constant'
import icAddSquare from 'assets/images/ic-add-square.svg'
import Table from 'components/commons/table'
import ModalDelete from 'components/commons/modal-delete'
import DateRangePicker from 'components/commons/date-range-picker'
import Sort from 'components/commons/sort'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import ModalExport from 'components/commons/modal-export'
import { FormUserMembership } from 'components/loyalty-program/user-membership/FormUserMembership'

export const UserMembership = ({
    dataList,
    modal,
    setShowModal,
    query,
    queryFilter,
    onChangeQuery,
    onSelectSort,
    onFilter,
    selectedIds,
    onExport,
    onDelete,
    onSelectItemHandler,
    onActionRow,
    onChangeForm,
    onSubmit,
    onHideForm,
    errorForm,
    isResetSelectedItem,
    userMembershipDetail,
    isLoading,
    isExporting,
    isDeleting,
    isCreating,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex gap-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <DateRangePicker
                        value={query?.start_date ? [query?.start_date, query?.end_date] : []}
                        onChange={(value) => onChangeQuery({ page: 1, start_date: value[0], end_date: value[1] })}
                        format={'YYYY-MM-DD'}
                    />
                    <Sort
                        options={SORT_USER_MEMBERSHIP}
                        value={`${query?.order_by}-${query?.order_type}`}
                        onSelect={(value) => onSelectSort(value)}
                    />
                    <Filter
                        show={modal?.filter}
                        setShow={(value) => setShowModal({ filter: value })}
                        options={FILTER_USER_MEMBERSHIP}
                        values={queryFilter}
                        onSubmit={(value) => onFilter(value)}
                    />
                    <Button
                        title={'Export'}
                        icon={icLinkExternal}
                        type={'outline'}
                        disabled={!dataList?.total_result}
                        onClick={() => setShowModal({ export: true })}
                    />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!selectedIds?.length}
                        onClick={() => onActionRow(ACTION_TYPE.DELETE)}
                    />
                </div>
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create User Membership'}
                    onClick={() => onActionRow(ACTION_TYPE.CREATE)}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_USER_MEMBERSHIP.name}
                columns={TABLE_USER_MEMBERSHIP.column}
                data={dataList?.rows}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={selectedIds?.length || dataList?.total_result}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete User Membership'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.form && (
                <FormUserMembership
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataUserMembership={userMembershipDetail}
                    isLoading={isCreating}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
